import {Image, Skeleton, Spin} from "antd";
import {useState} from "react";

import "./index-image.css";
import PhotoOverlay from "../PhotoOverlay/PhotoOverlay";

function IndexImage(props) {
    const [showThisImage, setShowThisImage] = useState(true);

    function finishOnload() {
        setShowThisImage(false)
    }

    return (<>
        {showThisImage ?
            // <div>
            //     <img onError={finishOnload} className={"index-image-item"} alt={props["alt"]}
            //          src={props["src"]}
            //     />
            // </div>
            <PhotoOverlay
                src={props["src"]}
                title={props["name"]}
                link={props["link"]}
                priority={props.priority}
            />
            : <></>}
    </>)
}

export default IndexImage;
